import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetLastImportRequest,
	GetCommissioningPlanTableRequest,
	GetCommissioningPlanExportRequest,
	ImportCommissioningPlanRequest
} from '../requests/CommissioningPlanRequests.js';

export const GET_LAST_IMPORT = 'GET_LAST_IMPORT';
export const GET_COMMISSIONING_PLAN_TABLE = 'GET_COMMISSIONING_PLAN_TABLE';
export const TOGGLE_IMPORT_MODAL_VISIBILITY = 'TOGGLE_IMPORT_MODAL_VISIBILITY';

const onGetLastImport = (value) => ({
	type: GET_LAST_IMPORT,
	lastImport: value
});

export const GetLastImport = () => async (dispatch) => {
	await GetLastImportRequest().then(response => {
		dispatch(onGetLastImport(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetCommissioningPlanTable = (value) => ({
	type: GET_COMMISSIONING_PLAN_TABLE,
	commissioningPlanTableData: value
});

export const GetCommissioningPlanTable = () => async (dispatch) => {
	await GetCommissioningPlanTableRequest().then(response => {
		dispatch(onGetCommissioningPlanTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetCommissioningPlanExport = () => async (dispatch) => {
	await GetCommissioningPlanExportRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleImportModalVisibility = (visible) => ({
	type: TOGGLE_IMPORT_MODAL_VISIBILITY,
	importModalVisibility: visible
});

export const ToggleImportModalVisibility = (visible) => (dispatch) => {
	dispatch(onToggleImportModalVisibility(visible));
};

export const ImportCommissioningPlan = (filePath) => async (dispatch) => {
	await ImportCommissioningPlanRequest(filePath).then(response => {
		dispatch(GetCommissioningPlanTable());
		dispatch(GetLastImport());
		dispatch(enqueueSnackbar({ message: 'Commissioning Plan successfully imported!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadCommissioningPlan = (file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ImportCommissioningPlan(response.data));
		dispatch(ToggleImportModalVisibility(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
